import { useRouter } from 'next/router'
import styled from 'styled-components'

import { useGetUser } from 'src/hooks/useGetUser'
import { useGetPosts } from 'src/hooks/posts/useGetPosts'
import { isEmpty } from '@/util/objectHelpers'

import Spinner from 'src/components/Spinner'

const SingleUser = () => {
  const router = useRouter()
  const { username } = router.query
  const { user: { id, avatar, description, headline, url }, isLoading } = useGetUser({ username })

  if (isLoading) return <Spinner />
  if (!id) return null

  return (
    <div className="w-full font-soehne-kraftig mt-2 p-4">
      <UserInfo>
        <ProfileIcon src={avatar} />
        <ButtonContainer>
          <Button onClick={() => router.push(`/creators/profile/${username}/edit`)}>
            Edit Profile
          </Button>
        </ButtonContainer>
        <h1 className="uppercase tracking-wide text-center text-md mb-2 text-bold">@{username}</h1>
        <Text>{headline}</Text>
        <br />
        <LightText>{description}</LightText>
        <br />
        <Text>
          <a href={url}>{url}</a>
        </Text>
      </UserInfo>

      <Posts id={id} />
    </div>
  )
}

const Posts = ({ id }) => {
  const { posts } = useGetPosts({ userId: id })

  if (posts.length <= 0 || isEmpty(posts)) return null

  return (
    <PostContainer>
      {posts.map((post) => (
        <Post key={post.id} post={post} />
      ))}
    </PostContainer>
  )
}

const Post = ({ post }) => (
  <Container key={post.id}>
    <Thumbnail src={post.coverImg} />
  </Container>
)

const Text = styled.span.attrs({ className: 'font-soehne-leight' })``
const LightText = styled.span.attrs({ className: 'font-soehne-xleight' })``

const UserInfo = styled.div`
  padding: 4px 8px;
  margin-bottom: 20px;
`

const ProfileIcon = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: block;
  margin: 12px auto;
`

const PostContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
`

const Button = styled.button`
  border: 1px solid #adadad;
  border-radius: 8px;
  color: white;
  background: #546433;
  padding: 8px 15px;
  font-size: 14px;
  height: 40px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
`

const Container = styled.div`
  width: 33%;
`

const Thumbnail = styled.img``

export default SingleUser
